export class AppParameter {
  constructor(public readonly name: string) {
    if (!name) {
      throw new Error('AppRouteParameter must have a non-empty name');
    }

    if (name.includes('/')) {
      throw new Error('AppRouteParameter cannot have a name containing \'/\'');
    }

    if (name.startsWith(':')) {
      const trimmedName = name.slice(1);

      if (!trimmedName) {
        throw new Error('AppRouteParameter must have a non-empty name');
      }

      this.name = trimmedName;
    }
  }
}
